module.exports = __webpack_public_path__ + "static/image_1-bc5901a3a1882c6481a7d173a47b88ca.jpg";